export const LOADER_I18N_ENTRIES = {
  loader_Data1: {
    es: '<p>Cargando...</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
